module.exports = __webpack_public_path__ + "media/images/logo5-2ed5a61066fca562e31aeb2b8ffbd759.jpg";